import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/auth";
import ModalComponent from "../Modal/ModalComponent";
import "./CheckShift.css";

const CheckShift = ({ children }) => {
  const { user, signOut } = useAuth();
  const [isOutsideShift, setIsOutsideShift] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const currentDate = new Date();
  const currentDay = currentDate.getDay(); // 0: Domingo, ... 6: Sábado
  const currentTime = currentDate.getHours() * 60 + currentDate.getMinutes();

  const operatorShift = user?.userData?.operador?.shift;

  const checkIfInShift = () => {
    if (operatorShift) {
      const workDays = operatorShift.days_of_week.map((day) => {
        switch (day) {
          case "Domingo":
            return 0;
          case "Segunda":
            return 1;
          case "Terça":
            return 2;
          case "Quarta":
            return 3;
          case "Quinta":
            return 4;
          case "Sexta":
            return 5;
          case "Sábado":
            return 6;
          default:
            return -1;
        }
      });

      const [startHour, startMin] = operatorShift.start_time.split(":");
      const [endHour, endMin] = operatorShift.end_time.split(":");
      const startMinutes = parseInt(startHour) * 60 + parseInt(startMin);
      const endMinutes = parseInt(endHour) * 60 + parseInt(endMin);

      if (
        !workDays.includes(currentDay) ||
        currentTime < startMinutes ||
        currentTime > endMinutes
      ) {
        setIsOutsideShift(true);
        setShowModal(true);
      } else {
        setIsOutsideShift(false);
      }
    }
  };

  useEffect(() => {
    if (user?.userData?.tipo_usuario === "operador") {
      checkIfInShift();
    }
  }, [user]);

  const handleLogout = () => {
    signOut();
  };

  return (
    <>
      <ModalComponent
        modalIsOpen={showModal}
        handleConfirm={handleLogout}
        modalText="Você está fora do seu horário de trabalho. Por favor, entre no seu turno para acessar."
        buttonLabel1="Sair"
        hideCancelButton={true}
      />
      {!isOutsideShift ? children : null}
    </>
  );
};

export default CheckShift;
